import React, { useEffect, useState } from 'react';
import { ReportsCountersTaxiBusiness } from '../../../shared/types';
import { getLastSeenText } from '../../../shared/Utils';

const RidersStatus = ({ data, title }) => {
    const [countersData, setCountersData] = useState<ReportsCountersTaxiBusiness>();
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        if (data) setCountersData(data);
    }, [data]);

    // Detect screen size
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 480);
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    if (!countersData || !countersData.statusRiders) {
        return (
            <div
                style={{
                    width: '80%',
                    maxWidth: '500px',
                    margin: '0 auto',
                    background: '#fff',
                    borderRadius: '12px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                    padding: isMobile ? '10px' : '16px',
                    textAlign: 'center',
                    fontSize: '13px',
                    color: '#666',
                }}
            >
                Loading rider status...
            </div>
        );
    }

    const riders = countersData.statusRiders;
    const enableScroll = riders.length > 4;

    return (
        <div
            style={{
                width: '100%',
                maxWidth: '500px',
                margin: '0 auto',
                background: '#fff',
                borderRadius: '12px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                padding: isMobile ? '10px' : '16px',
            }}
        >
            <h3
                style={{
                    textAlign: 'center',
                    marginBottom: 10,
                    fontSize: isMobile ? '13px' : '14px',
                    fontWeight: 600,
                }}
            >
                {title} &nbsp;
                <span style={{ fontSize: '12px', color: '#666' }}>({countersData.totalOnlineRiders} Online)</span>
            </h3>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                    ...(enableScroll && {
                        maxHeight: '220px', // adjust height to your design
                        overflowY: 'auto',
                        paddingRight: '6px', // add some space for scrollbar
                    }),
                }}
            >
                {riders.map((rider, index) => (
                    <div
                        key={index}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            background: '#fafafa',
                            padding: '6px 10px',
                            borderRadius: '10px',
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <img
                                src={rider.riderPhoto}
                                alt={rider.riderName}
                                style={{
                                    width: 32,
                                    height: 32,
                                    borderRadius: '50%',
                                    objectFit: 'cover',
                                }}
                            />

                            <div style={{ lineHeight: '1.2' }}>
                                <div style={{ fontSize: '13px', fontWeight: 500 }}>{rider.riderName}</div>
                                <div style={{ fontSize: '10px' }}>{getLastSeenText(Number(rider.updatedDate))}</div>
                            </div>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                fontWeight: 600,
                                fontSize: '12px',
                                color: rider.isRiderOnline ? '#34A853' : '#999',
                            }}
                        >
                            {/* Dot */}
                            <span
                                style={{
                                    width: '8px',
                                    height: '8px',
                                    borderRadius: '50%',
                                    backgroundColor: rider.isRiderOnline ? '#34A853' : '#999999',
                                    display: 'inline-block',
                                }}
                            ></span>

                            {/* Text */}
                            <span>{rider.isRiderOnline ? 'Online' : 'Offline'}</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default RidersStatus;
